'use client';

import { useRouter } from '@bprogress/next';
import ChatModal from '@c/modals/ChatModal';
import Button from '@ui/Button';
import { ADMIN_UID } from '@util/support';
import { useAuth } from 'context/AuthContext';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

const ContactSupport = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { userDoc } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <ChatModal
        isOpen={modalOpen}
        dismiss={() => setModalOpen(false)}
        recipientUid={ADMIN_UID}
      />

      <Button
        text="Contact Support"
        type="secondary"
        onClick={() => {
          if (userDoc) {
            setModalOpen(true);
          } else {
            router.push(`/login?redirect=${encodeURI(pathname ?? '')}`);
          }
        }}
      />
    </>
  );
};

export default ContactSupport;
